import React, { useEffect, useMemo, useState } from "react";
// Redux
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getDistributionStatus,
  getOrderStatus,
  getToken,
  resetAuth,
  setToken,
  setUserInfo,
} from "../../features/auth/authSlice";
// utils
import { toast } from "react-toastify";
import Spinner from "../../components/util/Spinner";
import { resetSetting } from "../../features/setting/settingSlice";
import { resetOrder, resetSearchSort } from "../../features/order/orderSlice";
import { getMyAccount } from "../../features/profile/profileSlice";

const Login = () => {
  // Form Data
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");

  //   redux
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  //   Login Handler
  const navigate = useNavigate();

  function useQuery() {
    const { search } = useLocation();

    return useMemo(() => new URLSearchParams(search), [search]);
  }
  const query = useQuery();
  const token = query.get("token");

  useEffect(() => {
    if (token) {
      dispatch(getMyAccount(token))
        .unwrap()
        .then(({ res, newToken }) => {
          if (res.data && res.data.result === "success" && newToken) {
            dispatch(setToken(newToken));
            dispatch(getOrderStatus(newToken));
            dispatch(getDistributionStatus(newToken));
            dispatch(setUserInfo(res.data.value));
            setLoading(true);
            setTimeout(() => {
              setLoading(false);
              navigate("/order-status");
            }, [1000]);
          }
        })
        .catch((error) => {});
    }
  }, [token, dispatch, navigate]);

  const loginHandler = (e) => {
    e.preventDefault();
    dispatch(resetSearchSort());
    dispatch(resetOrder());
    dispatch(resetSetting());
    dispatch(resetAuth());
    dispatch(
      getToken({
        user_id: userId,
        password,
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.data.result === "success") {
          dispatch(setToken(res.headers.get("Authorization")));
          dispatch(getOrderStatus(res.headers.get("Authorization")));
          dispatch(getDistributionStatus(res.headers.get("Authorization")));
          dispatch(setUserInfo(res.data.value));
          setLoading(true);
          setTimeout(() => {
            setLoading(false);
            navigate("/order-status");
            setUserId("");
            setPassword("");
            toast.success("Logged in successfully");
          }, [1000]);
        }
      })
      .catch((error) => {
        if (
          error.response.data.description ===
          "error login: password does not match"
        ) {
          toast.error("Bad User Credentials");
        } else {
          toast.error("Something went wrong!");
        }
      });
  };

  if (loading) return <Spinner text="ログイン中..." />;
};

const inputStyle =
  "border-[1px] px-2 py-[2px] border-gray-400 outline-none focus:border-orange-400";

export default Login;
